module.exports = __webpack_public_path__ + "static/media/tank.dcbacaa1.PNG";